export enum PaymentMethod {
  nutakuSp = 'nutaku-sp',
  nutakuClient = 'nutaku-client',
  seqpay = 'seqpay',
  centrobill = 'centrobill',
}
